import { HttpInterceptorFn, HttpErrorResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, throwError } from 'rxjs';
import { AuthService } from '../services/auth.service';
import { Router } from '@angular/router';
import { ToastService } from '../services/toast.service';

export const errorInterceptor: HttpInterceptorFn = (req, next) => {
  const authService = inject(AuthService);
  const router = inject(Router);
  const toastService = inject(ToastService);

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      if (error.status === 401) {
        // Check if this is a password change request or other user-specific operations
        // Don't logout for these endpoints
        const isPasswordChange = req.url.includes('/auth/change-password');
        const isProfileUpdate = req.url.includes('/auth/profile');
        const isLoginAttempt = req.url.includes('/auth/login');
        
        if (!isPasswordChange && !isProfileUpdate && !isLoginAttempt) {
          // Unauthorized - token expired or invalid
          authService.logout();
          toastService.error('Session Expired', 'Please login again');
          router.navigate(['/login']);
        }
        // For password change, profile update, or login - let the component handle the error
      } else if (error.status === 403) {
        // Forbidden - insufficient permissions
        toastService.error('Access Denied', 'You do not have permission to perform this action');
      } else if (error.status >= 500) {
        // Server error
        toastService.error('Server Error', 'Something went wrong. Please try again later.');
      }
      
      return throwError(() => error);
    })
  );
};